import { useEffect } from "react"
import { Form, Row, Col, Button } from "react-bootstrap"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { getForSelect as getAnimalsForSelect } from '../../../actions/other/animalsActions'
import { getBooleanOptions } from "../../../constants/booleanOptions"
import { getBirthProcessTypeOptions } from "../../../constants/birthProcessTypeOptions"

export default function EventFormBirthProcess({ type, state, handleInputChange, submit, isRegistering, isAddingOrEditing }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const { animalsForSelect } = useSelector(state => state.animals)

	useEffect(() => {
		dispatch(getAnimalsForSelect())
	}, [dispatch])

	const animals = animalsForSelect.map(a => ({ value: a._id, label: a.identifier }))

    const birthProcessTypeOptions = getBirthProcessTypeOptions(t)
    const booleanOptions = getBooleanOptions(t)

	return (
		<Form onSubmit={submit} className="formulario">
			<h1 className="mb-4">{t('menus.event_birthProcess')}</h1>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.animal.animals')}</Form.Label>
						<Select
							options={animals}
							value={animals.find(opt => state.animals?.[0] === opt.value) || null}
							onChange={opt => handleInputChange({ target: { name: 'animals', value: [opt.value] } })}
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.birthType')}</Form.Label>
						<Select
							options={birthProcessTypeOptions}
							value={birthProcessTypeOptions.find(o => o.value === state.birthType) || null}
							onChange={opt => handleInputChange({ target: { name: 'birthType', value: opt.value } })}
						/>
					</Form.Group>
				</Col>
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.reviewMother')}</Form.Label>
						<Select
							options={booleanOptions}
							value={booleanOptions.find(o => o.value === state.reviewMother) || null}
							onChange={opt => handleInputChange({ target: { name: 'reviewMother', value: opt.value } })}
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.calfDead')}</Form.Label>
						<Select
							options={booleanOptions}
							value={booleanOptions.find(o => o.value === state.calfDead) || null}
							onChange={opt => handleInputChange({ target: { name: 'calfDead', value: opt.value } })}
						/>
					</Form.Group>
				</Col>
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.reviewQuestion')}</Form.Label>
						<Select
							options={booleanOptions}
							value={booleanOptions.find(o => o.value === state.review) || null}
							onChange={opt => handleInputChange({ target: { name: 'review', value: opt.value } })}
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row className="mt-4">
				<Col>
					<Button type="submit" className="w-100" variant="primary">
						{isRegistering
							? <span className="spinner-border spinner-border-sm" />
							: isAddingOrEditing === 'editing'
								? t('admin.animal.edit')
								: t('admin.animal.register')
						}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}
